import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_panel/zadania/tematyczne/nowe')({
  beforeLoad: () => {
    throw redirect({ to: '/zadania/projekty/nowe' })
  },
})
